// This list of fields is used to clear contract only questions when changing between commercial and contract
export const CONTRACT_ONLY_HISTORY_FIELD_PATHS = [
	"account.history.largestProjectCompleted",
	"account.history.failedToCompleteAProject",
	"account.history.lostAPaymentSuit",
	"account.history.constructionProjectsGrossLossGt10PercentLast36Months",
	"account.history.currentConstructionProjectExpectedGrossLoss",
] as const;

export const shouldShowContractHistoryQuestions = (
	isCommercialSuretyEnabled: boolean,
	requiresPaymentAndPerformanceBonds: boolean | undefined,
) => !isCommercialSuretyEnabled || requiresPaymentAndPerformanceBonds !== false;
